<template>
  <div class="pa-3">
    <div class="pa-3">
      <v-layout row wrap>
        <v-flex class="text-right" md12 xs12 sm12>
          <v-btn-toggle v-model="display" right mandatory :value="0" :light="true">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on">
                  <v-icon>grid_on</v-icon>
                </v-btn>
              </template>
              <span>Table View</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on">
                  <v-icon>mdi-calendar-range</v-icon>
                </v-btn>
              </template>
              <span>Calendar View</span>
            </v-tooltip>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </div>
    <div v-if="display === 0">
      <v-row>
        <v-col cols="12">
          <div v-if="filteredItems.length > 0">
            <report-table
            :headers="headers"
            :filteredItems="filteredItems"
            :loading="loading"
            :refresh="tableRefresh"
            @viewInfluencers="viewInfluencers"
            @updated="refreshTableView"
            />
          </div>
        </v-col>
      </v-row>
      <influencer-modal
        :headers="influencerHeaders"
        :filteredItems="filteredInfluencers"
        :filter="influencerFilter"
        :campaign="selectedCampaign"
        :overall="overallTotals"
        :posted="postedTotals"
        :postedDeliverables="deliverableTotals"
        :totals="filterInfTotals"
        :value="viewInfluencerDialog"
        :loading="infLoading"
        @filtered="filterInfluencerList"
        @dataTableFiltered="infDataTableFiltered"
        @closed="closeInfModal"
      />
    </div>
    <div v-if="display === 1">
      <v-row>
        <v-col cols="12">
          <calendar-table
            :headers="calendarHeaders"
            :calendarMonths="showMonths"
            :filteredItems="filteredCalCampaigns"
            :filter="calendarFilter"
            @filterDate="filterMonth"
            @changeMonth="changeMonth"
            :loading="loading"
            :disableLeftArrow="disableLeftArrow"
            :disableRightArrow="disableRightArrow"
            />
        </v-col>
      </v-row>
    </div>

    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="180"
      height.number="180"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import config from '@/config';
import campaignConfig from '../config';
import reportConfig from './config';
import Loading from 'vue-loading-overlay';
import ReportTable from './ReportTable.vue'
import CalendarTable from './CalendarTable.vue'
import InfluencerModal from './InfluencerModal.vue'
import campaignHelper from '../campaignHelper';
import userAPIs from '../../User/userAPIs';
import moment from 'moment'
import utils from '@/utils';
export default {
  name: 'AOKReport',
  components: {
    ReportTable,
    CalendarTable,
    InfluencerModal,
    Loading
  },
  computed: {
    ...mapState({
      campaigns: state => state.campaign.campaigns,
      reports: state => state.campaign.reports,
      bfsLists: state => state.campaign.bfsLists,
      pairings: state => state.pairing.pairings
    })
  },
  data () {
    return {
      headers: reportConfig.reportTableHeader,
      influencerHeaders: reportConfig.influencerHeaders,
      defaultCalHeaders: reportConfig.defaultCalHeaders,
      overallTotals: {},
      postedTotals: {},
      deliverableTotals: {},
      filterInfTotals: {
        followers: 0,
        completedForm: 0,
        imsReview: 0,
        numberOfReviews: 0
      },
      tableRefresh: false,
      calendarHeaders: [],
      influencerFilter: '',
      calendarFilter: '',
      filteredItems: [], // filtered AOK Report Campaigns
      influencers: [], // default influencers
      filteredInfluencers: [], // filtered influencers view
      calendarCampaigns: [], // default calendar view campaigns
      filteredCalCampaigns: [], // filtered calendar view campaigns
      allMonthLists: [], // for monthly table lists
      showMonths: [], // only display monthly lists
      disableLeftArrow: false, // to enable/disable next arrow of monthly table
      disableRightArrow: true, // to enable/disable previous arrow of monthly table
      loading: false,
      infLoading: false,
      CO: [],
      selectedCampaign: {},
      viewInfluencerDialog: false,
      display: 0
    }
  },
  watch: {
    display(value) {
      if (value === 0) {
        this.loadTableView()
      }
    }
  },
  async mounted() {
    this.loading = true
    await this.init()
    this.loadTableView()
    this.loadCalendarView()
    this.loading = false
  },
  methods: {
    async init() {
      await this.$store.dispatch('campaign/getCampaigns')
      await this.$store.dispatch('pairing/getPairings')
      await this.getCOLists()
      this.filteredItems = Object.assign([], this.campaigns)
    },
    async refreshTableView() {
      this.tableRefresh = false
      await this.init()
      this.loadTableView()
      this.tableRefresh = true
    },
    loadTableView() {
      this.updateItems()
    },
    updateItems() {
      this.filteredItems = this.filteredItems.filter(item => {
        return item.campaignType && campaignHelper.isAOKCampaign(item.campaignType)
      })
      this.filteredItems = this.filteredItems.map(item => {
        item.inCharge = this.CO.filter(co => item.assignedTo && item.assignedTo.includes(co.id)).map(co => co.name).join(', ')
        item.pairings = this.pairings.filter(pairing => pairing.campaignID === item.id &&
        pairing.pairing_details &&
        pairing.pairing_details.status === campaignConfig.pairingStatus.ACCEPTED)
        item.actualOnboarded = item.pairings.length
        item.coverageKPI = item.max_content || 0
        item.onboardKPI = item.kpi_onboarded || ''
        let targetOnboardKPI = this.calcTdyOnboardKPI(item)
        if (targetOnboardKPI) {
          if (targetOnboardKPI > item.onboardKPI) {
            item.todayOnboardKPI = item.onboardKPI
          } else item.todayOnboardKPI = targetOnboardKPI
          if (item.todayOnboardKPI > item.actualOnboarded) item.lowonboardKPI = true
        }
        if (item.actualOnboarded && item.todayOnboardKPI) {
          item.currentProgress = ((item.actualOnboarded / item.todayOnboardKPI) * 100).toFixed(2)
        } else item.currentProgress = 0
        if (item.actualOnboarded && item.onboardKPI) {
          item.totalAchieved = ((item.actualOnboarded / item.onboardKPI) * 100).toFixed(2)
        } else item.totalAchieved = 0
        return item;
      });
      this.updateReportItems()
    },
    async updateReportItems() {
      let campaignIDs = this.filteredItems.map(item => item.id)
      await this.$store.dispatch('campaign/getReportsByCampaignIDs', campaignIDs)
      if (this.reports.length > 0) {
        this.filteredItems = this.filteredItems.map(item => {
          item.campaignReports = this.reports.filter(report => report.campaignID === item.id && !report.imported)
          item.coverageActual = item.campaignReports.length || 0
          item.numberOfReviewers = this.getReviewersCount(item.campaignReports)
          item.achieved = ((item.coverageActual / item.coverageKPI) * 100).toFixed(2)
          return item
        })
      }
    },
    async viewInfluencers(item) {
      this.selectedCampaign = item
      this.influencers = []
      item.pairings.map(pairing => {
        let inf = {}
        let infDetails = pairing.influencer_details
        inf.pairingID = pairing.id
        inf.handle = infDetails.instagramHandle
        inf.platform = infDetails.platform || 'instagram'
        inf.followers = infDetails.followers
        inf.pairingStatus = pairing.pairing_details.status
        inf.completedForm = pairing.completedForm || 0
        let influencerReports = item.campaignReports.filter(rpt => {
          let owner = rpt.owner ? rpt.owner.toLowerCase() : undefined
          let handle = inf.handle ? inf.handle.toLowerCase() : undefined
          if (rpt.isTikTok) {
            return inf.platform === 'tiktok' && owner === handle
          }
          return owner === handle
        })
        inf.imsReview = influencerReports.length > 0 ? 1 : 0
        inf.deliverables = campaignHelper.getReportDeliverables(influencerReports)
        inf.deliverablesObj = campaignHelper.getReportDeliverables(influencerReports, 'object')
        inf.numberOfReviews = influencerReports.length
        this.influencers.push(inf)
      })
      this.calculateInfSummary()
      this.filteredInfluencers = Object.assign([], this.influencers)
      this.viewInfluencerDialog = true
    },
    calculateInfSummary() {
      // calc summary totals
      this.overallTotals = utils.func.refreshJSON(reportConfig.overallTotals)
      this.overallTotals.influencers.value = this.influencers.length
      this.overallTotals.reviewers.value = this.influencers.map(c => c.numberOfReviews || 0).reduce((a, b) => a + b, 0)
      this.overallTotals.followers.value = this.influencers.map(c => c.followers || 0).reduce((a, b) => a + b, 0)
      // calc posted totals
      this.postedTotals = utils.func.refreshJSON(reportConfig.postedTotals)
      this.postedTotals.reviewOutreach.value = this.influencers.map(c => c.numberOfReviews * c.followers).reduce((a, b) => a + b, 0)
      this.postedTotals.totalFollower.value = this.influencers.filter(c => c.numberOfReviews > 0).map(c => c.followers || 0).reduce((a, b) => a + b, 0)
      this.postedTotals.tiktokContents.value = this.influencers.map(c => c.deliverablesObj.TTP).reduce((a, b) => a + b, 0)
      this.postedTotals.tiktokOutreach.value = this.influencers.map(c => c.platform === 'tiktok' ? (c.numberOfReviews * c.followers) : 0).reduce((a, b) => a + b, 0)
      this.postedTotals.instagramContent.value = this.influencers
      .map(c => c.deliverablesObj.IGS +
      c.deliverablesObj.IGV +
      c.deliverablesObj.IGR +
      c.deliverablesObj.IGC +
      c.deliverablesObj.IGP)
      .reduce((a, b) => a + b, 0)
      this.postedTotals.instagramOutreach.value = this.influencers.map(c => c.platform === 'instagram' ? (c.numberOfReviews * c.followers) : 0).reduce((a, b) => a + b, 0)
      // calc deliverableTotals
      this.deliverableTotals = utils.func.refreshJSON(reportConfig.postedDeliverables)
      this.influencers.map(inf => {
        let deliverables = inf.deliverablesObj
        for (var key of Object.keys(deliverables)) {
          this.deliverableTotals[key].value += deliverables[key]
        }
      });
    },
    async loadCalendarView() {
      // get monthly KPI onboard based on campaign start date and end date
      let statuses = [
        config.campaignStatus.ONGOING,
        config.campaignStatus.PAIRING
      ]
      await this.$store.dispatch('campaign/getCampaigns', { statuses })
      await this.$store.dispatch('campaign/getBFSLists')
      this.calendarCampaigns = Object.assign([], this.campaigns)
      this.filteredCalCampaigns = Object.assign([], this.calendarCampaigns)
      this.formatCalCampaigns({ colorChange: true })
    },
    calcTdyOnboardKPI(item) {
      if (!item.startDate || !item.endDate || !item.onboardKPI) return '';
      const durationMonths = campaignHelper.getCampaignDurationMonths(item)
      const totalWeeks = utils.func.totalWeeksOfMonth()
      const weekDurations = utils.func.weekDurations(item.startDate)
      return Math.round((item.onboardKPI / (durationMonths * totalWeeks)) * weekDurations)
    },
    formatCalCampaigns(options = {}) {
      // format calendar campaign lists for data table and set all campaign month lists
      let allMonths = []
      this.filteredCalCampaigns = this.filteredCalCampaigns.map(item => {
        item.poc = this.CO.filter(co => item.assignedTo && item.assignedTo.includes(co.id)).map(co => co.name).join(', ')
        item.bfs = this.getBFSByCampaign(item)
        item.onboardKPI = item.kpi_onboarded || ''
        item.todayOnboardKPI = this.calcTdyOnboardKPI(item)
        if (options.colorChange) item.bgColor = utils.func.getRandomColor()
        let monthlyData = this.getCampaignMonthlyData(item)
        if (monthlyData) {
          for (let month of monthlyData.months) {
            item[month] = monthlyData.contentPerMonth
          }
          allMonths.push(...monthlyData.months)
        }
        allMonths = [...new Set(allMonths)];
        return item
      })
      this.setCalendarMonthHeaders(allMonths)
    },
    setCalendarMonthHeaders(months) {
      // set calendar months header from month lists set
      this.allMonthLists = [...months]
      this.allMonthLists = this.allMonthLists.filter(m => m || false)
      this.allMonthLists = this.allMonthLists.sort((a, b) => {
        return new Date(a) - new Date(b);
      })
      let currentYear = moment().format('YYYY')
      let currentYearMonths = this.allMonthLists.filter(m => m.includes(currentYear))
      let currentYearCount = currentYearMonths.length
      let lastYearCount = currentYearCount < 12 ? 12 - currentYearCount : 0
      this.showMonths = [...currentYearMonths]
      if (this.showMonths.length > 0) {
        let firstCurrentYearIndex = this.allMonthLists.indexOf(this.showMonths[0]);
        for (let i = 1; i <= lastYearCount; i++) {
          let monthIndex = firstCurrentYearIndex - i
          if (this.allMonthLists[monthIndex]) {
            this.showMonths.unshift(this.allMonthLists[monthIndex])
          }
        }
      }
      this.setShowMonthsHeader(this.showMonths)
    },
    filterMonth(dateRange) {
      if (!dateRange.startDate || !dateRange.endDate) {
        this.formatCalCampaigns()
        this.resetMonthArrows()
        return false
      }
      let startDate = dateRange.startDate
      let endDate = dateRange.endDate
      let durationMonths = utils.func.monthDurations(startDate, endDate)
      let months = []
      for (let i = 0; i < durationMonths; i++) {
        let futureMonth = moment(startDate).add(i, 'M').format('YYYY-MM')
        months.push(futureMonth)
      }
      this.setCalendarMonthHeaders(months)
    },
    changeMonth(type) {
      if (type === 'next') {
        let lastIndex = this.allMonthLists.indexOf(this.showMonths[this.showMonths.length - 1])
        let nextMonth = this.allMonthLists[lastIndex + 1]
        if (nextMonth) {
          this.showMonths.shift()
          this.showMonths.push(nextMonth)
          this.disableLeftArrow = false
        } else this.disableRightArrow = true
      } else {
        let firstIndex = this.allMonthLists.indexOf(this.showMonths[0])
        let previousMonth = this.allMonthLists[firstIndex - 1]
        if (previousMonth) {
          this.showMonths.pop()
          this.showMonths.unshift(previousMonth)
          this.disableRightArrow = false
        } else this.disableLeftArrow = true
      }
      this.setShowMonthsHeader(this.showMonths)
    },
    setShowMonthsHeader(months) {
      this.calendarHeaders = Object.assign([], this.defaultCalHeaders)
      months.map(month => {
        this.calendarHeaders.push(Object.assign({}, {
          text: utils.func.formatMonth(month),
          value: month
        }))
      })
    },
    getCampaignMonthlyData(item) {
      // calc diff months between campaign start and end date, and contents per month
      const durationMonths = campaignHelper.getCampaignDurationMonths(item)
      if (!durationMonths) {
        return false
      }
      let contentPerMonth = Math.round(item.onboardKPI / durationMonths)
      let months = []
      for (let i = 0; i < durationMonths; i++) {
        let futureMonth = moment(item.startDate).add(i, 'M').format('YYYY-MM')
        months.push(futureMonth)
      }
      return { months, contentPerMonth }
    },
    getReviewersCount(reports) {
      let uniqueHandles = [...new Set(reports.map(rpt => rpt.owner ? rpt.owner.toLowerCase() : ''))]
      return uniqueHandles.length
    },
    async getCOLists() {
      // Get all CO by role
      let response = await userAPIs.getAllUsersByRole(config.userRoles.AD_STRATEGIST)
      if (response) {
        this.CO = response.users
        this.CO = this.CO.map(co => {
          co.name = `${co.firstName} ${co.lastName}`
          return co
        })
      }
    },
    getBFSByCampaign(item) {
      let bfsOne = this.bfsLists.find(bfs => bfs.campaignID === item.id)
      if (bfsOne) return bfsOne.id
      return null
    },
    filterInfluencerList(searchData) {
      this.filteredInfluencers = Object.assign([], this.influencers)
      if (searchData.completedForm || searchData.completedForm === 0) {
        this.filteredInfluencers = this.filteredInfluencers.filter(item => item.completedForm === searchData.completedForm)
      }
      if (searchData.imsReview || searchData.imsReview === 0) {
        this.filteredInfluencers = this.filteredInfluencers.filter(item => item.imsReview === searchData.imsReview)
      }
    },
    infDataTableFiltered(filtered) {
      this.filterInfTotals.followers = filtered.map(c => c.followers || 0).reduce((a, b) => a + b, 0)
      this.filterInfTotals.completedForm = filtered.length
      this.filterInfTotals.imsReview = filtered.length
      this.filterInfTotals.numberOfReviews = filtered.map(c => c.numberOfReviews || 0).reduce((a, b) => a + b, 0)
    },
    resetMonthArrows() {
      this.disableLeftArrow = false
      this.disableRightArrow = true
    },
    closeInfModal() {
      this.viewInfluencerDialog = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?469345a5